import classNames from "classnames/bind";
import styles from "./index.module.scss";
import { Card } from "antd";
import { useTranslation } from "react-i18next";
import { useEffect, useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import userEventApi from "api/userEvent";

const cx = classNames.bind(styles);

export default function SuccessConfirm() {
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();

    const confirmQrCode = useCallback(async (userId) => {
        try {
            await userEventApi.update(userId, { isConfirmQr: true });
        } catch (error) {
            console.log("🚀 ~ error:", error)
        }
    }, []);

    useEffect(() => {
        const id = searchParams.get('id');
        if (id) {
            confirmQrCode(id);
        }
    }, [searchParams]);

    return (
        <div className={cx("page-success")}>
            <Card className={cx("success-card")}>
                <div className={cx("title")}>{t('confirmJoinSuccess')}</div>
            </Card>
        </div>
    );
}
